import { ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { getStyle } from '@utils/style';

interface NavigationButtonProps {
  disabled?: boolean;
  onPress: () => void;
  label: string;
  valid?: boolean;
  direction: 'left' | 'right';
}

interface StyledProps {
  disabled?: boolean;
  valid?: boolean;
}

const IconContainer = styled.div<StyledProps>`
  background-color: #3d3d3d;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  height: ${({ theme }) => (theme.isMobile ? '40px' : '56px')};
  width: ${({ theme }) => (theme.isMobile ? '40px' : '56px')};
  display: flex;

  ${({ valid, disabled }) =>
    valid &&
    !disabled &&
    css`
      background-color: ${getStyle('PRIMARY_COLOR', true)};
    `}
`;

const IconImage = styled.img<StyledProps>`
  height: ${({ theme }) => (theme.isMobile ? '16px' : '20px')};

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
`;

const Label = styled.span`
  margin: 0 ${({ theme }) => (theme.isMobile ? '10px' : '15px')};
  font-size: ${({ theme }) => (theme.isMobile ? '16px' : '20px')};
  color: #000;
`;

const Button = styled.button`
  flex-direction: row;
  align-items: center;
  background: none;
  margin: 0;
  padding: 0;
  border: none;
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:focus-visible {
    outline: 2px solid ${getStyle('PRIMARY_COLOR', true)};
    outline-offset: 2px;
  }
`;

export const NavigationButtonV2 = ({
  disabled = false,
  onPress,
  label,
  valid = false,
  direction
}: NavigationButtonProps): ReactElement => {
  return (
    <Button
      disabled={disabled}
      onClick={onPress}
      type="button"
      aria-label={`${direction} navigation: ${label}`}
    >
      {direction === 'left' && (
        <IconContainer valid={valid} disabled={disabled}>
          <IconImage src={require('../assets/icons/left-icon.png')} disabled={disabled} alt="" />
        </IconContainer>
      )}
      <Label>{label}</Label>
      {direction === 'right' && (
        <IconContainer valid={valid} disabled={disabled}>
          <IconImage src={require('../assets/icons/right-icon.png')} disabled={disabled} alt="" />
        </IconContainer>
      )}
    </Button>
  );
};
